import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Box, Column, Columns, Text } from '../../../../../../../lib/base';
import { DEFAULT_TEXT_SIZE_DESCRIPTIONS } from '../../../../../../Constants';
import { isValidHexColor } from '../../../../../../../store/system/helper'

export default class SqlSpatialLegend extends Component {
  static propTypes = {
    /**
     * Legend data.
     */
    layer: PropTypes.object.isRequired,
  };

  render() {
    const { layer } = this.props;
    let canvas = document.createElement("CANVAS");
    let ctx = canvas.getContext("2d");
    canvas.width = 20;
    canvas.height = 20;
    let layerColor;
    if (layer.color) {
      layerColor = layer.color.indexOf("#") > -1 ? layer.color : "#" + layer.color;
      if (!isValidHexColor(layerColor)) {
        layerColor = "#FFFFFF";
      }
    } else {
      return null;
    }
    ctx.fillStyle = layerColor;
    ctx.fillRect(0, 0, 20, 20);
    ctx.strokeRect(0, 0, 20, 20);
    let dataUrl = canvas.toDataURL();

    return (
      <Columns vCenter>
        <Column flex={4 / 5}>
          <Text size={DEFAULT_TEXT_SIZE_DESCRIPTIONS}>{layer.legendDesc}</Text>
        </Column>
        <Column flex={1 / 5}>
          <Box textAlign="right">
            <img
              width="24"
              height="24"
              alt={layer.layerName}
              src={dataUrl}
              style={{ backgroundColor: 'white' }}
            />
          </Box>
        </Column>
      </Columns>
    );
  }
}
